import { render, staticRenderFns } from "./BankCardManagement.vue?vue&type=template&id=2b4a5ecd&scoped=true&"
import script from "./BankCardManagement.vue?vue&type=script&lang=js&"
export * from "./BankCardManagement.vue?vue&type=script&lang=js&"
import style0 from "./BankCardManagement.vue?vue&type=style&index=0&id=2b4a5ecd&scoped=true&lang=css&"
import style1 from "./BankCardManagement.vue?vue&type=style&index=1&id=2b4a5ecd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a5ecd",
  null
  
)

export default component.exports